import React from "react";
import { Alert, AlertDescription, Box, Flex } from "@chakra-ui/react";
import { envConfig } from "@/config";
import { ChakraFAIcon } from "@/components/ui/Icon";

type MaxStudentsMessageProps = {
	studentCount: number;
};

export const MaxStudentsMessage: React.FC<MaxStudentsMessageProps> = ({ studentCount }) => {
	const maxStudents = envConfig.MAX_STUDENTS;
	if (!studentCount || studentCount <= maxStudents) {
		return <></>;
	}
	return (
		<Flex>
			<Alert status="warning" bgColor="#FFE8EA" mb="16px" pt="12px" width="unset">
				<Box mx="8px" pt="-4px">
					<ChakraFAIcon icon="fa-triangle-exclamation" variant="solid" color="#FF0000" />
				</Box>
				<AlertDescription fontSize="14px" fontWeight="500" pt="2px">
					Total students: {studentCount}. Changes cannot be made as there are more than {maxStudents} students in this class.
				</AlertDescription>
			</Alert>
		</Flex>
	);
};
